import ApiBaseService from './ApiBaseService.js';

class EmployeeService {
    static getProfile([company_uuid, employee_uuid]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}`, 'GET');
    }
    // * To set companyUUID and employeeUUID
    // * To store employee name and logo in state
    static listCompanies() {
        return ApiBaseService.request('/api/company', 'GET', null);
    }

    // ! Remove once bug is fixed in API.
    static getShifts([company_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/shift`, 'GET');
    }

    static getLeaveQuota([company_uuid, employee_uuid]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leavequota`, 'GET');
    }
    static changeEmplyeeStatus([company_uuid, employee_uuid, statusID]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/status/${statusID}`, "GET");
    }
    static changeEmplyee2FAStatus([company_uuid, employee_uuid, enableStatus]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/mfa/${enableStatus}`, "GET");
    }
    static getleavequotacycle([company_uuid, employee_uuid, statusID]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/leavequotacycle`, "GET");
    }

    // expense
    static getEmployeeDayExpenses([company_uuid, employee_uuid, startDate, endDate, pagination = 0]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/expense?type=day&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
    }
    static getEmployeeWeekExpenses([company_uuid, employee_uuid, startDate, endDate, pagination = 0]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/expense?type=week&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
    }
    static getEmployeeMonthExpenses([company_uuid, employee_uuid, startDate, endDate, pagination = 0]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/expense?type=month&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
    }
    static addEmployeeExpense([company_uuid, employee_uuid, data]) {
        return ApiBaseService.request(`/api/company/${company_uuid}/employee/${employee_uuid}/expense`, "POST", data);
    }
    static updateEmployeeExpense([company_uuid, employee_uuid, expense_uuid, data]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/expense/${expense_uuid}`, "PUT", data);
    }
    static deleteEmployeeExpense([company_uuid, employee_uuid, expense_uuid]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/expense/${expense_uuid}`, "DELETE");
    }
    static getEmployeeExpenseApprovals([company_uuid, employee_uuid, type, startDate, endDate, pagination = 0]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/approval/expense?type=${type}&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
    }
    static reviewExpenseRequest([company_uuid, employee_uuid, data]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/approval/expense`, "PUT", data);
    }

    // Notiications
    static notificationList([company_uuid, employee_uuid, page, limit, pagination]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification?page=${page}&limit=${limit}&pagination=${pagination}`, "GET");
    }
    static notifiReadStatus([company_uuid, employee_uuid, notificationUUID]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification/${notificationUUID}`, "PUT");
    }
    static allReadNotification([company_uuid, employee_uuid]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification-read-all`, "PUT");
    }
    static unreadCount([company_uuid, employee_uuid]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification-unread-count`, "GET");
    }
    static UnreadList([company_uuid, employee_uuid, unreadOnly, limit]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification?unread-only=${unreadOnly}&limit=${limit}`, "GET");
    }
    static NotifiSettingsList([company_uuid, employee_uuid, unreadOnly, limit]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification?unread-only=${unreadOnly}&limit=${limit}`, "GET");
    }
    static notifiChange([company_uuid, employee_uuid, unreadOnly, limit]) {
        return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/notification?unread-only=${unreadOnly}&limit=${limit}`, "PUT");
    }


}

export default EmployeeService;
